import { render, staticRenderFns } from "./GalleriesListView.vue?vue&type=template&id=03893456&scoped=true&"
import script from "./GalleriesListView.vue?vue&type=script&lang=js&"
export * from "./GalleriesListView.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesListView.vue?vue&type=style&index=0&id=03893456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03893456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VContainer,VSheet})
